// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { autoCompleteSharedStyles } from "@sc/App/WidgetExtensions/Header/SearchInputExtensions";
import {
    autocompleteCategoriesStyles,
    AutocompleteCategoriesStyles,
} from "@sc/Overrides/Widgets/Header/AutocompleteCategories";
import { color, mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const autocompleteCategoriesStylesExtensions: AutocompleteCategoriesStyles = {
    headerText: {
        ...autoCompleteSharedStyles?.headerText,
    },
    link: {
        ...autoCompleteSharedStyles?.link,
    },
    focusedCategoryItemText: {
        ...mergeWithCss(autoCompleteSharedStyles?.focusedItemText, {
            css: css`
                display: flex;
                flex-direction: column;
                background: ${color("common.ui3")};
            `,
        }),
    },
    focusedLink: {
        ...mergeWithCss(autoCompleteSharedStyles.focusedLink, {
            typographyProps: {
                weight: "bold",
            },
        }),
    },
    categoryItemText: {
        ...mergeWithCss(autoCompleteSharedStyles?.itemText, {
            css: css`
                cursor: pointer;
                display: flex;
                flex-wrap: wrap;
                gap: 4px;
            `,
        }),
    },
};

autocompleteCategoriesStyles.headerText = autocompleteCategoriesStylesExtensions.headerText;
autocompleteCategoriesStyles.link = autocompleteCategoriesStylesExtensions.link;
autocompleteCategoriesStyles.focusedCategoryItemText = autocompleteCategoriesStylesExtensions.focusedCategoryItemText;
autocompleteCategoriesStyles.focusedLink = autocompleteCategoriesStylesExtensions.focusedLink;
autocompleteCategoriesStyles.categoryItemText = autocompleteCategoriesStylesExtensions.categoryItemText;
